<template>
  <div>
    <h3 class="border-bottom pb-1 gold">
      <span v-text="data.title"></span>: <small v-text="data.sub_title"></small>
    </h3>

    <pre class="space-pre-line p-3" v-html="main_text"></pre>

    <div v-if="data.media">
      <!-- 
			TODO: Check that data.media can actually be more than one.
			If it is, then remove the v-for or set data.media[0] with checks
			-->
      <div v-for="(media, k) in data.media" :key="'media_' + k">
        <div class="d-flex">
          <audio
            v-if="media !== ''"
            id="'audio_tag_' + k"
            @canplay="updatePaused"
            @playing="updatePaused"
            @play="play"
            @pause="updatePaused"
            @ended="finished"
            @timeupdate="updatePlayTime"
            controls
            controlsList="nodownload"
          >
            <source :src="media" type="audio/mpeg" />
          </audio>
          <!-- Only show savebutton if time left is larger than audio total duration - currentTime -->
          <template
            v-if="
              audio_sound &&
                paused &&
                duration > audio_sound.duration - currentTime
            "
          >
            <b-button size="sm" variant="outline-success" @click="saveProgress">
              <i data-v-c19ac878="" class="fas fa-cloud-upload-alt fa-2x"></i>
              Save Progress
            </b-button>
          </template>
        </div>
      </div>
      <div v-if="is_saved" class="text-success">Meditation Saved!</div>
    </div>

    <div class="border-top text-right">
      <b-button class="mt-3" @click="hideModal()">Cancel</b-button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import NoSleep from "nosleep.js";
var noSleep = new NoSleep();
import DOMPurify from "isomorphic-dompurify";

export default {
  name: "CourseMeditation",
  props: {
    data: {
      type: Object,
      default: null,
    },
    modal_id: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      audio_sound: null,
      currentTime: 0,
      duration: 0,
      paused: null,
      is_saved: false,
    };
  },
  mounted() {
    noSleep.enable();
  },
  methods: {
    hideModal() {
      noSleep.disable();
      this.audio_sound = null;
      this.$bvModal.hide(this.modal_id);
    },
    updatePlayTime() {
      if (this.paused) {
        // on drag of the player position, set new duration to be
        // time left on player
        this.duration =
          this.audio_sound.duration - this.audio_sound.currentTime;
      }
      this.currentTime = this.audio_sound.currentTime;
    },
    uploadMeditationTime() {
      console.log("submit meditation");
      let params = new URLSearchParams();
      params.append("token", this.$store.state.session_id);
      params.append("date", "now");
      params.append("totalTime", this.duration - this.currentTime);
      params.append("default_min", Math.floor(this.duration / 60));
      var now = new Date();
      var TZ_offset = now.getTimezoneOffset();
      params.append("timezone_offset", TZ_offset);

      return axios({
        url: this.$store.state.api_url + "meditationAdd",
        params: params,
      });
    },
    saveProgress() {
      this.currentTime = this.audio_sound.currentTime;
      let _this = this;
      this.uploadMeditationTime()
        .then(function() {
          // set new duration

          _this.duration = _this.audio_sound.duration - _this.currentTime;
          _this.is_saved = true;
          setTimeout(() => {
            _this.is_saved = false;
          }, 1000);
        })
        .catch(function(e) {
          console.log(e);
        })
        .finally(function() {});
    },

    finished() {
      this.currentTime = this.audio_sound.currentTime;

      //console.log('courseGet:' + this.profile.id);
      let _this = this;
      let params = new URLSearchParams();
      params.append("token", _this.$store.state.session_id);
      params.append("course_id", this.data.course_id);
      params.append("section_id", this.data.id);
      params.append("user_id", _this.$store.state.profile.id);
      params.append("duration", this.duration);
      params.append("type", "meditation");

      axios({
        method: "post",
        url: _this.$store.state.api_url + "courseSectionComplete",
        data: params,
      })
        .then(function() {
          return _this.uploadMeditationTime();
        })
        .then(function(response) {
          console.log(response.data);
          location.reload();
        })
        .catch(function(e) {
          console.log("Error: finished:" + e);
        });
    },

    updatePaused(event) {
      this.audio_sound = event.target;
      this.paused = event.target.paused;
    },
    play(event) {
      if (event) {
        // on play set audio_sound to the audio target
        this.audio_sound = event.target;

        // if duration is zero, on start, then set it to be the
        // total audio duration
        if (this.duration === 0) this.duration = this.audio_sound.duration;
      }
    },
  },
  computed: {
    playing() {
      return !this.paused;
    },
    main_text() {
      // use regex to detect if main_text contains links
      // if contains links, wrap with an anchor tag
      // also sanitise using DOMPurify
      const regex = /\b(https?:\/\/\S*\b)/g;
      return DOMPurify.sanitize(
        this.data.main_text.replace(regex, '<a href="$1">$1</a>')
      );
    },
  },
  watch: {},
};
</script>

<style scoped>
/* Overwrite pre styling with existing */
pre.space-pre-line {
  white-space: pre-line;
  font-size: inherit;
  color: inherit;
  border: initial;
  padding: initial;
  font-family: inherit;
}
</style>
